import { render, staticRenderFns } from "./Quays.vue?vue&type=template&id=79de247a&scoped=true&"
import script from "./Quays.vue?vue&type=script&lang=js&"
export * from "./Quays.vue?vue&type=script&lang=js&"
import style0 from "./Quays.vue?vue&type=style&index=0&id=79de247a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79de247a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VAlert,VVirtualScroll})
